import * as types from "./types";
import INITIAL_STATE from "./init";

import { REHYDRATE_STATE } from "state/modules/root/types";

const STATUS_COUNT_MAP = { REQUEST: "pendingCount", SUCCESS: "completedCount" };

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case REHYDRATE_STATE: {
      return { ...state, rehydrated: true };
    }
    case types.CLEAR_LOADING_STATUS: {
      const updatedState = { ...state };
      delete updatedState[action.payload];
      return updatedState;
    }
    default: {
      const matches = /(.*)_(REQUEST|SUCCESS|ERROR)/.exec(action.type);
      if (!matches) return state;

      const [, label, status] = matches;
      const loadingState = state[label] || {};
      const count = loadingState[STATUS_COUNT_MAP[status]] || 0;

      return {
        ...state,
        [label]: {
          ...state[label],
          status: status === "REQUEST", // true if loading
          [STATUS_COUNT_MAP[status]]: count + 1,
        },
      };
    }
  }
};
